export default "__VITE_PUBLIC_ASSET__78308071__"